import script from "./Pagination.vue?vue&type=script&setup=true&lang=js"
export * from "./Pagination.vue?vue&type=script&setup=true&lang=js"

import "./Pagination.vue?vue&type=style&index=0&id=072d9648&scoped=true&lang=css"
script.__scopeId = "data-v-072d9648"

export default script